import React from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { Dropdown, Form, Icon, Input, Label } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

interface Props extends FieldComponentProps {
  icon?: string
}

const PhoneNumberField: React.FC<Props> = ({ field, name, countries = [], icon = 'mobile alternate', disabled }) => {
  const { control } = useFormContext()
  const { t } = useTranslation()

  const prefixName = `${name}.value`
  const numberName = `${name}.value2`
  const required = !disabled && Boolean(field.fieldRequired)

  const { field: prefix, fieldState: prefixState } = useController({
    control,
    name: prefixName,
    rules: required ? { required: t('Please select code') } : {}
  })

  const { field: number, fieldState: numberState } = useController({
    control,
    name: numberName,
    rules: required ? { required: t('Please enter phone number') } : {}
  })

  const errorMessage = prefixState.error?.message || numberState.error?.message
  const hasError = Boolean(errorMessage)

  return (
    <Form.Field required={required} error={hasError} style={{ paddingLeft: 0 }}>
      <label style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
        <Icon name={icon as any} style={{ fontSize: '1.2em' }} />
        <LabelWithInfo label={<div>{field.label}</div>} info={field.info} required={required} />
      </label>
      <Input
        value={number.value || ''}
        error={hasError}
        disabled={disabled}
        label={
          <Dropdown
            scrolling
            basic
            clearable
            disabled={disabled}
            error={Boolean(prefixState.error)}
            options={countries.map(country => ({
              value: country.id,
              text: country.phoneCode,
              flag: country.iso
            }))}
            selectOnBlur={false}
            value={parseInt(prefix.value) || ''}
            onChange={(e, data) => prefix.onChange(data.value)}
            onBlur={prefix.onBlur}
            placeholder={t('Code')}
            name={prefixName}
          />
        }
        onChange={(e, data) => number.onChange(data.value)}
        onBlur={number.onBlur}
        labelPosition='left'
        style={{ marginBottom: hasError ? 4 : 10 }}
        type='number'
        placeholder={prefix.value ? field.placeholder : t('Please select mobile code')}
        name={numberName}
      />
      {hasError && <Label prompt pointing='above'>{errorMessage}</Label>}
    </Form.Field>
  )
}

export default PhoneNumberField
